import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import AdvisorPredeterminedAllocationForm from '@/components/advisor-predetermined-allocation-form/advisor-predetermined-allocation-form';
import ConfirmDialog from '@/components/confirm-dialog';
import {useConfirmDialogActions} from '@/components/confirm-dialog/use-confirm-dialog-actions';
import ContainerCard from '@/components/container-card';
import {useBlockNavigationIfFormDirty} from '@/hooks/use-block-navigation-if-form-dirty';

const AllocationCreation: FunctionComponent = () => {
  const {t} = useTranslation();
  const {setIsFormDirty, isNavigationBlocked, onConfirmNavigation, onCancelNavigation} =
    useBlockNavigationIfFormDirty();

  const confirmDialogActions = useConfirmDialogActions({
    onCancel: onCancelNavigation,
    onConfirm: onConfirmNavigation,
  });

  return (
    <>
      <div className="flex grow flex-row gap-4">
        <ContainerCard>
          <ContainerCard.Content className="mt-0">
            <AdvisorPredeterminedAllocationForm onDirtyChange={setIsFormDirty} />
          </ContainerCard.Content>
        </ContainerCard>
      </div>

      <ConfirmDialog
        isVisible={isNavigationBlocked}
        actions={confirmDialogActions}
        title={t('components.advisor-profile-form.navigation-confirm.title')}
        text={t('components.advisor-profile-form.navigation-confirm.text')}
      />
    </>
  );
};

export default AllocationCreation;
